<template>
  <section
    v-if="front.bannerEntries.length"
    id="home"
    class="hero section-observed"
    :class="{ 'is-clickable': hasJumpLink }"
    @click="onHeroClick"
  >
    <div class="hero-media" aria-hidden="true">
      <div class="hero-media__stack">
        <img
          v-for="(banner, index) in front.bannerEntries"
          :key="banner.coverUrl || banner.mediaUrl || banner.fileUrl || index"
          :class="{ 'is-active': index === front.activeBannerIndex }"
          :src="front.resolveBannerImage(banner)"
          alt=""
        >
      </div>
    </div>
    <div v-if="currentBanner" class="hero-caption">
      <h2 class="hero-caption__title">{{ currentBanner.title }}</h2>
      <time v-if="currentBannerDate" class="hero-caption__date">{{ currentBannerDate }}</time>
    </div>
    <div v-if="front.bannerEntries.length > 1" class="hero-nav" aria-label="首页轮播" @click.stop>
      <button type="button" class="hero-nav__btn hero-nav__btn--prev" aria-label="上一张" @click="goPrev">
        <span aria-hidden="true">‹</span>
      </button>
      <button type="button" class="hero-nav__btn hero-nav__btn--next" aria-label="下一张" @click="goNext">
        <span aria-hidden="true">›</span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroBanner',
  inject: ['front'],
  computed: {
    currentBanner() {
      const list = this.front.bannerEntries || []
      return list[this.front.activeBannerIndex] || list[0] || null
    },
    currentBannerDate() {
      if (!this.currentBanner) return ''
      return this.front.formatDate(this.currentBanner.publishTime || this.currentBanner.createTime)
    },
    jumpLink() {
      const entryId = this.currentBanner && this.currentBanner.entryId
      if (entryId) {
        return `/content/${entryId}`
      }
      return ''
    },
    hasJumpLink() {
      return !!this.jumpLink
    }
  },
  methods: {
    onHeroClick() {
      if (!this.jumpLink) return
      this.front.goPath(this.jumpLink)
    },
    goPrev() {
      const total = this.front.bannerEntries.length
      if (total <= 1) return
      this.front.activeBannerIndex = (this.front.activeBannerIndex - 1 + total) % total
      this.front.startBannerCarousel()
    },
    goNext() {
      const total = this.front.bannerEntries.length
      if (total <= 1) return
      this.front.activeBannerIndex = (this.front.activeBannerIndex + 1) % total
      this.front.startBannerCarousel()
    }
  }
}
</script>
